import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { firestore } from "../firebase";
import { COLLECTIONS } from "../constants/data";
import { getRouteRule } from "./routeRules";
import { setMenuId } from "../features/menu/menu.slice";
import { setRestaurantId } from "../features/restaurant/restaurant.slice";
import { setSessionId } from "../features/session/session.slice";
import { setApprovementId } from "../features/approvement/approvement.slice";

const RouteGuard = ({ children }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { 
    link_alias,
    quid,
    restaurant: restaurantId,
    menu: menuId,
    dits: sessionId,
    requestId,
  } = useParams<{ 
    link_alias: string, 
    quid:string,
    restaurant: string,
    menu: string,
    dits: string,
    requestId: string,
  }>();

  useEffect(() => {
    // Extract IDs from path params or query
    console.log(`ROUTE_GUARD [${restaurantId}] [${menuId}] [${sessionId}] [${requestId}]`);
    dispatch(setRestaurantId(restaurantId || null));
    dispatch(setMenuId(menuId || null));
    dispatch(setSessionId(sessionId || null));
    dispatch(setApprovementId(requestId || null));
  }, [location.pathname, restaurantId, menuId, sessionId, requestId, dispatch]);

  const user = useSelector((state: RootState) => state.auth.firestoreUser);

  useEffect(() => {
    if(!user) return;
    if(!restaurantId) return;
    if(!sessionId) return;

    const currentExternalTable = user?.current_external_active_dine_in_table_sitting;
    const ditsRef = firestore.collection(COLLECTIONS.restaurants).doc(restaurantId)
      .collection(COLLECTIONS.dineInTableSitting).doc(sessionId);

    const rule = getRouteRule(location.pathname, {link_alias, quid});
    if(!rule || !rule.requiresTable) return;
    if(!currentExternalTable || currentExternalTable !== ditsRef.path){
      navigate(rule.fallback, {replace: true});
    }
  }, [user, restaurantId, sessionId, location.pathname]);

  return children || null;
};

export default RouteGuard;